import { Medication } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { CategoryFindingSummary } from "Backend";
import theme from "theme";
import { P } from "theme/typography";

interface PharmacyFindingsProps {
  prescriptionFinding: CategoryFindingSummary;
  onViewFindings: () => void;
}

const PharmacyFindings = ({ prescriptionFinding, onViewFindings }: PharmacyFindingsProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        position: "relative",
        border: `1px solid ${theme.palette.grey[100]}`,
        justifyContent: "space-between",
        alignItems: "center",
        mr: 2,
        p: 2,
        ml: 1,
        mt: 1,
      }}>
      <P
        variant="overline"
        sx={{
          color: "grey.400",
          backgroundColor: "grey.50",
          position: "absolute",
          left: 16,
          top: -8,
          display: "block",
          px: 1,
        }}>
        Pharmacy Findings Detected
      </P>
      <P variant="body4">
        <b>{prescriptionFinding.count}</b> findings across <b>{prescriptionFinding.documentCount}</b> document
        {prescriptionFinding.documentCount === 1 ? "" : "s"}
      </P>
      <div></div>
      <Button size="small" startIcon={<Medication />} variant="contained" onClick={onViewFindings}>
        View Pharmacy Findings Table
      </Button>
    </Box>
  );
};

export default PharmacyFindings;
